import { useEffect, useState } from "react";
import { api } from "../api";
import { Reveal } from "./Reveal";
import { useApp } from "../store";

let cache = null;
const listeners = new Set();

const fetchMedia = () => {
  api
    .get("/gallery")
    .then((r) => {
      cache = r.data.items || [];
      listeners.forEach((fn) => fn(cache));
    })
    .catch(() => {});
};

export const useMediaItems = () => {
  const [items, setItems] = useState(cache);
  useEffect(() => {
    if (cache) {
      setItems(cache);
      return;
    }
    listeners.add(setItems);
    fetchMedia();
    return () => listeners.delete(setItems);
  }, []);
  return items || [];
};

const isVideo = (url = "") => /\.(mp4|webm|mov)(\?|$)/i.test(url);

export const SectionMedia = ({ section, light = false }) => {
  const { lang } = useApp();
  const items = useMediaItems().filter((m) => (m.section || "realisations") === section);

  if (items.length === 0) return null;

  return (
    <div data-testid={`section-media-${section}`} className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items.map((item, i) => (
        <Reveal key={item.id} delay={Math.min(i, 5) * 0.06}>
          <figure
            data-testid={`section-media-item-${item.id}`}
            className={`group relative overflow-hidden border aspect-video ${
              light ? "border-[var(--accent-soft)]/10 bg-white/[0.05]" : "border-white/10 bg-[#172A45]"
            }`}
          >
            {isVideo(item.url) ? (
              <video src={item.url} controls playsInline preload="metadata" className="w-full h-full object-cover" />
            ) : (
              <img
                src={item.url}
                alt={(lang === "fr" ? item.caption_fr : item.caption_en) || section}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            )}
            {(item.caption_fr || item.caption_en) && (
              <figcaption className="absolute inset-x-0 bottom-0 bg-[#0B132B]/85 backdrop-blur px-4 py-3 text-sm text-white/85">
                {lang === "fr" ? item.caption_fr : item.caption_en || item.caption_fr}
              </figcaption>
            )}
          </figure>
        </Reveal>
      ))}
    </div>
  );
};
